var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 136,
    viewBox: "0 0 107 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.8213 91.7792L36.3321 85.193C38.3043 84.7936 40.1675 86.1372 40.7485 88.2387C42.6958 95.2969 48.4036 99.7066 56.2584 99.7066C63.4255 99.7066 68.019 95.887 68.019 90.0589C68.019 68.351 5.54613 76.3919 5.54613 36.9977C5.54613 15.4918 25.0231 0.417725 52.584 0.417725C80.145 0.417725 99.9737 14.9766 103.555 36.0831C103.939 38.3435 102.661 40.545 100.607 41.0397L69.5237 48.5586C67.5605 49.0329 65.6428 47.7552 65.0119 45.6672C63.1395 39.4783 58.8774 35.7881 53.3193 35.7881C47.7613 35.7881 44.1324 39.004 44.1324 43.8289C44.1324 63.9277 106.973 54.6817 106.973 96.4884C106.973 119.603 86.0253 135.883 55.5253 135.883C25.0253 135.883 3.51038 119.976 0.689373 96.3885C0.428379 94.1985 1.83548 92.1809 3.8213 91.7792Z",
    fill: "#DA716A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSLetter);
export default __webpack_public_path__ + "static/media/s-letter.26f8a6f9fd2b213b932e293a63a8ef79.svg";
export { ForwardRef as ReactComponent };